<template>
    <div>
        <img class="img" :src="templateArgs.data.imagem || imgDefault"  @error="placeholder" />
    </div>
</template>

<script>
export default {
    name: 'templateImages',
    data: () => ({
        templateArgs: {}
    }),
    computed: {
        imgDefault() {
            return require('../assets/sem-imagem-publicidade2.jpg')
        }
    },
    methods: {
        placeholder(e) {
            e.target.src = require('../assets/sem-imagem-publicidade2.jpg')
        },
    },
}
</script>

<style lang="scss" scoped>
.img {
    width: 70px;
    height: 70px;
    object-fit: cover;
}
</style>